import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

// import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Layout from './layouts'

// auth
import Login from './pages/auth/login';
import Register from './pages/auth/register';
import ResetPassword from './pages/auth/reset-password';
import LockScreen from './pages/auth/lockscreen';

// //pages
import Dashboard from './pages/dashboard';
//Widgets
import WidgetsApps from './pages/widgets-apps';
import WidgetsData from './pages/widgets-data';
// //apps
import AppCalendar from './pages/app-calendar';
import AppChat from './pages/app-chat';
import AppTicket from './pages/app-ticket';
import AppContact from './pages/app-contact';
import AppContactDetail from './pages/app-contact-detail';
// //Charts
import ChartC3 from './pages/chart-c3';
import ChartChartjs from './pages/chart-chartjs';
import ChartFlot from './pages/chart-flot';
import ChartMorris from './pages/chart-morris';
import ChartRadial from './pages/chart-radial';
import ChartRickshaw from './pages/chart-rickshaw';
import ChartSparkline from './pages/chart-sparkline';
// new chart
// Charts 
import Apexcharts from "./pages/charts/ApexCharts/Apexcharts";
import GoogleCharts from "./pages/charts/GoogleCharts/GoogleCharts";
import KnobChart from "./pages/charts/KnobChart/KnobChart";
import Chartsjs from "./pages/charts/Chartsjs/Chartsjs";
import Chartist from "./pages/charts/ChartistCharts/Chartist";

// //EXAMPLES
import CorporateAdd from './pages/corporate-add';
import CorporatePages from './pages/corporate-pages';
import EcommerceAdd from './pages/ecommerce-add';
import EcommerceOrders from './pages/ecommerce-orders';
import EcommerceProducts from './pages/ecommerce-products';
import ExamplesAddAndUpdate from './pages/examples-add-and-update';
import ExamplesDelete from './pages/examples-delete';

// //form
import FormBasic from './pages/form-basic';
import FormEditor from './pages/form-editor';
import FormFileUpload from './pages/form-file-upload';
import FormMasks from './pages/form-masks';
import FormPicker from './pages/form-picker';
import FormValidations from './pages/form-validations';
import FormWizard from './pages/form-wizard';
import MailCompose from './pages/mail-compose';
import MailIndex from './pages/mail-index';
import MailView from './pages/mail-view';
import MapGoogle from './pages/map-google';
import MapVector from './pages/map-vector';

// //page
import PageBlank from './pages/page-blank';
import PageFaqs from './pages/page-faqs';
import PageGallery from './pages/page-gallery';
import PageInvoice from './pages/page-invoice';
import PagePricing from './pages/page-pricing';
import PageProfile from './pages/page-profile';
import PageTimeline from './pages/page-timeline';
import TableBasic from './pages/table-basic';
import DataTables from './pages/table-data';
import Transactions from './pages/transactions';
import TransactionsDetails from './pages/transactions-details';
import Products from './pages/products'
import ProductsDetails from './pages/products-details';
import Stores from './pages/stores';
import StoresDetails from './pages/stores-details';
import Users from './pages/users';
import UsersDetails from './pages/users-details';
import Settings from './pages/settings';

// ui element
import UiBootstrapElements from './pages/ui-bootstrap-elements';
import UiAlertify from './pages/ui-alertify';
import UiButtons from './pages/ui-buttons';
import UiCardMaster from './pages/ui-card-master';
import UiCards from './pages/ui-cards';
import UiCarousel from './pages/ui-carousel';
import UiDraggableCards from './pages/ui-draggable-cards';
import UiGrid from './pages/ui-grid';
import UiIcons from './pages/ui-icons';
import UiJqueryElements from './pages/ui-jquery-elements';
import UiModals from './pages/ui-modals';
import UiNestable from './pages/ui-nestable';
import UiNotification from './pages/ui-notification';
import UiProgress from './pages/ui-progress';
import UiRangeSlider from './pages/ui-range-slider';
import UiSweetalerts from './pages/ui-sweetalerts';
import UiTabs from './pages/ui-tabs';
import UiTipPop from './pages/ui-tip-pop';
import UiTreeview from './pages/ui-treeview';
import UiTypography from './pages/ui-typography';
import Page404 from './pages/page-error/page-404';

import { LoadingProvider } from './services/redux-services/LoadingContext';
import { SignalRProvider } from './services/signalR/SignalRProvider';
import { BreadcrumbProvider } from './services/breadcrumb-services/BreadcrumbContext';
import { UserProvider } from './services/redux-services/UserInfoContext';
import { LanguageProvider } from './services/language/LanguageContext';

ReactDOM.render(
  <LoadingProvider>
    <LanguageProvider>
      <UserProvider>
      <SignalRProvider>
        <BreadcrumbProvider>
          <BrowserRouter basename={'/'} >
            <Routes>

              <Route path="/auth" element={<Layout />}>
                <Route index element={<Navigate to="/auth/login" replace />} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="forget-password" element={<ResetPassword />} />
                <Route path="lock-screen" element={<LockScreen />} />
              </Route>

              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="transactions/:id" element={<TransactionsDetails />} />
                <Route path="products" element={<Products />} />
                <Route path="products/:id" element={<ProductsDetails />} />
                <Route path="stores" element={<Stores />} />
                <Route path="stores/:id" element={<StoresDetails />} />
                <Route path="users" element={<Users />} />
                <Route path="users/:id" element={<UsersDetails />} />
                <Route path="settings" element={<Settings />} />
                <Route path="app-calendar" element={<AppCalendar />} />
                <Route path="app-chat" element={<AppChat />} />
                <Route path="app-contact-detail" element={<AppContactDetail />} />
                <Route path="app-contact" element={<AppContact />} />
                <Route path="app-ticket" element={<AppTicket />} />

                <Route path="chart-c3" element={<ChartC3 />} />
                <Route path="chart-chartjs" element={<ChartChartjs />} />
                <Route path="chart-flot" element={<ChartFlot />} />
                <Route path="chart-morris" element={<ChartMorris />} />
                <Route path="chart-radial" element={<ChartRadial />} />
                <Route path="chart-rickshaw" element={<ChartRickshaw />} />
                <Route path="chart-sparkline" element={<ChartSparkline />} />

                <Route path="chart-apex" element={<Apexcharts />} />
                <Route path="chart-Google" element={<GoogleCharts />} />
                <Route path="chart-Knob" element={<KnobChart />} />
                <Route path="chart-js" element={<Chartsjs />} />
                <Route path="chart-Chartist" element={<Chartist />} />

                <Route path="corporate-add" element={<CorporateAdd />} />
                <Route path="corporate-pages" element={<CorporatePages />} />

                <Route path="ecommerce-add" element={<EcommerceAdd />} />
                <Route path="ecommerce-orders" element={<EcommerceOrders />} />
                <Route path="ecommerce-products" element={<EcommerceProducts />} />

                <Route path="examples-add-and-update" element={<ExamplesAddAndUpdate />} />
                <Route path="examples-delete" element={<ExamplesDelete />} />
                <Route path="form-basic" element={<FormBasic />} />
                <Route path="form-editor" element={<FormEditor />} />
                <Route path="form-file-upload" element={<FormFileUpload />} />
                <Route path="form-masks" element={<FormMasks />} />
                <Route path="form-picker" element={<FormPicker />} />
                <Route path="form-validations" element={<FormValidations />} />
                <Route path="form-wizard" element={<FormWizard />} />

                <Route path="mail-compose" element={<MailCompose />} />
                <Route path="mail-index" element={<MailIndex />} />
                <Route path="mail-view" element={<MailView />} />
                <Route path="map-google" element={<MapGoogle />} />
                <Route path="map-vector" element={<MapVector />} />

                <Route path="page-blank" element={<PageBlank />} />
                <Route path="page-faqs" element={<PageFaqs />} />
                <Route path="page-gallery" element={<PageGallery />} />
                <Route path="page-invoice" element={<PageInvoice />} />
                <Route path="page-pricing" element={<PagePricing />} />
                <Route path="page-profile" element={<PageProfile />} />
                <Route path="page-timeline" element={<PageTimeline />} />

                <Route path="table-basic" element={<TableBasic />} />
                <Route path="table-data" element={<DataTables />} />

                {/* form and ui element */}
                <Route path="ui-bootstrap-elements" element={<UiBootstrapElements />} />
                <Route path="ui-alertify" element={<UiAlertify />} />
                <Route path="ui-buttons" element={<UiButtons />} />
                <Route path="ui-card-master" element={<UiCardMaster />} />
                <Route path="ui-cards" element={<UiCards />} />
                <Route path="ui-carousel" element={<UiCarousel />} />
                <Route path="ui-draggable-cards" element={<UiDraggableCards />} />
                <Route path="ui-grid" element={<UiGrid />} />
                <Route path="ui-icons" element={<UiIcons />} />
                <Route path="ui-jquery-elements" element={<UiJqueryElements />} />
                <Route path="ui-modals" element={<UiModals />} />
                <Route path="ui-nestable" element={<UiNestable />} />
                <Route path="ui-notification" element={<UiNotification />} />
                <Route path="ui-progress" element={<UiProgress />} />
                <Route path="ui-range-slider" element={<UiRangeSlider />} />
                <Route path="ui-sweetalerts" element={<UiSweetalerts />} />
                <Route path="ui-tabs" element={<UiTabs />} />
                <Route path="ui-tip-pop" element={<UiTipPop />} />
                <Route path="ui-treeview" element={<UiTreeview />} />
                <Route path="ui-typography" element={<UiTypography />} />
                <Route path="widgets-apps" element={<WidgetsApps />} />
                <Route path="widgets-data" element={<WidgetsData />} />

              </Route>
              <Route path='*' element={<Page404 />} />
            </Routes>
          </BrowserRouter>
          <ToastContainer
            position="top-right"
            autoClose={3500}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
          />
        </BreadcrumbProvider>
      </SignalRProvider>
    </UserProvider>
    </LanguageProvider>
  </LoadingProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
